import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const postAppointment = (data) => axios.post(`${API}/appointments`, data);
export const postEnquiry = (data) => axios.post(`${API}/enquiries`, data);

export const getInstagramFeed = async (account, limit = 6) => {
  if (!process.env.REACT_APP_BACKEND_URL) return null;
  try {
    const res = await axios.get(`${API}/instagram/feed`, { params: { account, limit } });
    const posts = Array.isArray(res.data?.posts) ? res.data.posts.filter((p) => p?.image && p?.permalink) : [];
    return res.data?.configured && posts.length ? { username: res.data?.username ?? null, posts } : null;
  } catch {
    return null;
  }
};

export const errorMessage = (err) => {
  const detail = err?.response?.data?.detail;
  if (Array.isArray(detail)) return `Please check: ${detail.map((d) => d?.loc?.slice(-1)[0]).join(", ")}`;
  return "Something went wrong. Please try again or email us directly.";
};
